import { INavRoute, IUserPermissions } from 'types'
import {
  ShipmentsIcon,
  LocationPinIcon,
  UserIcon,
  SettingsIcon,
  SearchIcon,
  HomeIcon,
  PeopleIcon,
  TrucksIcon,
  DashboardIcon,
} from 'transfix-icons'
import { filterRoutes } from 'utils/generateAppDefaults'
import { getUserCookieValues } from 'utils/userAuth'

interface IRoutesConfig {
  primary: INavRoute[]
  secondary?: INavRoute[]
}

/**
 * Returns a routes config object based on auth and user permissions
 */
export const generateFleetPlannerRoutes = (permissions: IUserPermissions | null): IRoutesConfig => {
  const { authToken } = getUserCookieValues()
  if (!authToken || !permissions) {
    return {
      primary: filterRoutes([
        {
          location: 'fms/login',
          name: 'Log In',
          IconEl: UserIcon,
          isStark: false,
          display: true,
        },
      ]),
    }
  }

  const primaryRoutes = [
    {
      location: 'fms/home',
      name: 'Home',
      IconEl: HomeIcon,
      display: true,
    },
    {
      location: 'fms/loads',
      name: 'My Loads',
      IconEl: ShipmentsIcon,
      display: true,
    },
    {
      location: 'fms/book',
      name: 'Book Loads',
      IconEl: SearchIcon,
      display: true,
    },
    {
      location: 'fms/fleet',
      name: 'Fleet',
      IconEl: DashboardIcon,
      display: true,
    },
    {
      location: 'fms/team',
      name: 'Team',
      IconEl: PeopleIcon,
      display: true,
    },
    {
      location: 'fms/carriers',
      name: 'Carriers',
      IconEl: TrucksIcon,
      display: true,
    },
    {
      location: 'fms/facilities',
      name: 'Facilities',
      IconEl: LocationPinIcon,
      display: true,
    },
  ]

  const secondaryRoutes = [
    {
      location: 'fms/user/settings',
      name: 'Settings',
      IconEl: SettingsIcon,
      display: true,
    },
  ]

  return {
    primary: filterRoutes(primaryRoutes.filter(route => route.display)),
    secondary: filterRoutes(secondaryRoutes.filter(route => route.display)),
  }
}
